module.exports = __webpack_public_path__ + "img/C05TechArchConstruction_ua.68740d58.webp";